import Lottie from "lottie-react";
import animationData from "../../../../assets/animations/tbSuccessfulPaymentAnimation.json";
import QuoteFormWrapper from "../../../../shared/components/quoteFormWrapper";

const ReportClaimSuccess = ({ onBack }) => (
  <QuoteFormWrapper>
    <div style={{ width: "44px", height: "44px" }} className="margin-bottom-20">
      <Lottie
        animationData={animationData}
        loop={false}
        autoplay={true}
        rendererSettings={{ preserveAspectRatio: "xMidYMid slice" }}
        style={{
          width: "100%",
          height: "100%",
          marginLeft: "-7px",
          marginTop: "-7px",
        }}
      />
    </div>
    <h1 className="margin-bottom-15">Success</h1>
    <p className="gray-text margin-bottom-20">
      Your claim has been submitted successfully!
    </p>
    <button type="button" onClick={onBack} className="getStartedButton">
      Back to Portal
    </button>
  </QuoteFormWrapper>
);

export default ReportClaimSuccess;
